/** Local preview candidates still require the server's local-render capability. */
export function isLocalPreviewHost(hostname: string): boolean {
  if (['127.0.0.1', 'localhost', '[::1]'].includes(hostname)) return true;
  const octets = hostname.split('.');
  if (octets.length !== 4 || octets.some(octet => !/^\d{1,3}$/.test(octet) || Number(octet) > 255)) return false;
  const [first, second] = octets.map(Number);
  return first === 10 || (first === 172 && second! >= 16 && second! <= 31)
    || (first === 192 && second === 168);
}
